module.exports = __webpack_public_path__ + "static/img/ostart.38c7b49.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ostart.png
// module id = Bb8D
// module chunks = 1